export const redirectToWsLogin = (wsUrl: string, hint: string, clientId: string, redirectUri: string, scope: string, responseType: string, state?: string, codeChallenge?: string, codeChallengeMethod?: string) => {

    const loginUrlParams = new URLSearchParams([
        ["login_hint", hint],
        ["client_id", clientId],
        ["redirect_uri", redirectUri],
        ["scope", scope],
        ["response_type", responseType]
    ]);

    if (state) {
        loginUrlParams.append("state", state);
    }

    if (codeChallenge) {
        loginUrlParams.append("code_challenge", codeChallenge);
    }

    if (codeChallengeMethod) {
        loginUrlParams.append("code_challenge_method", codeChallengeMethod);
    }

    const wsLoginUrl = `${wsUrl}/auth/connect/authorize?${loginUrlParams.toString()}`;

    window.location.replace(wsLoginUrl);
};